import { InjectionToken } from "@angular/core";
import { ICreateWidgetModalService } from "./i-create-widget-modal.service";

export const createWidgetModalServiceInjectionToken: InjectionToken<ICreateWidgetModalService> = new InjectionToken("digital-signage.developer-dashboard.dashboard-web.CreateWidgetModalService");
